import React from 'react';
import { useState, useEffect } from 'react';
import "./AboutYou.css";
import PartTimePeriod from "./PartTimePeriod.js"

import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';

import TextField from '@mui/material/TextField';
import DateAdapter from '@mui/lab/AdapterMoment';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DesktopDatePicker from '@mui/lab/DesktopDatePicker';

import Check from '@mui/icons-material/Check';
import AddCircleIcon from '@mui/icons-material/AddBoxOutlined';
import RemoveCircleIcon from '@mui/icons-material/Delete';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import FormLabel from '@mui/material/FormLabel';
import FormGroup from '@mui/material/FormGroup';
import FormHelperText from '@mui/material/FormHelperText';
import Checkbox from '@mui/material/Checkbox';

import NativeSelect from '@mui/material/NativeSelect';

import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import InfoIcon from '@mui/icons-material/InfoOutlined';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import { useHistory } from 'react-router-dom';
import moment from 'moment';



// These are the names of the bullet stepper used to indicate what stage of the inputs required the user is at
const steps = ['Basic information', 'Your earnings', 'Part-time service'];

// Color theme throughout 
const colorTheme = "#af292e";
export { colorTheme };

const themeGAD = createTheme({
    palette: {
      primary: {
        light: '#af292e',
        main: '#af292e',
        dark: '#af292e',
        contrastText: '#fff',
      },
      secondary: {
        light: '#ff7961',
        main: '#f44336',
        dark: '#ba000d',
        contrastText: '#000',
      },
    },
  });

  export {themeGAD};


// Style of the lines that connect the steppers
const StyledConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 12,
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundColor: colorTheme,
          },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundColor: colorTheme,
          },
    },
    [`& .${stepConnectorClasses.line}`]: {
      height: 3,
      border: 0,
      backgroundColor:
        theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
      borderRadius: 1,
    },
  }));

  // Style of the steppers 
  const StyledIconRoot = styled('div')(({ theme, ownerState }) => ({
    color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#eaeaf0',
    display: 'flex',
    height: 22,
    alignItems: 'center',
    ...(ownerState.active && {
      color: colorTheme,
    }),
    '& .StyledIcon-completedIcon': {
      color: colorTheme,
      zIndex: 1,
      fontSize: 18,
    },
    '& .StyledIcon-circle': {
      width: 8,
      height: 8,
      borderRadius: '50%',
      backgroundColor: 'currentColor',
    },
  }));

  // Function that renders a stepper
  function StyledIcon(props) {
    const { active, completed, className } = props;
    return (
      <StyledIconRoot ownerState={{ active }} className={className}>
        {completed ? (
        <Check className="StyledIcon-completedIcon" />
        ) : (
          <div className="StyledIcon-circle" />
        )}
      </StyledIconRoot>
    );
  }
  StyledIcon.propTypes = {
    /**
     * Whether this step is active.
     * @default false
     */
    active: PropTypes.bool,
    className: PropTypes.string,
    /**
     * Mark the step as completed. Is passed to child components.
     * @default false
     */
    completed: PropTypes.bool,
  };

  const StyledTextField = styled(TextField)({
    '& label.Mui-focused': {
        color: colorTheme,
      },
      '& .MuiInput-underline:after': {
        borderBottomColor: colorTheme,
      },
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: colorTheme,
        },
        '&:hover fieldset': {
          borderColor: colorTheme,
        },
        '&.Mui-focused fieldset': {
          borderColor: colorTheme,
        },
      },
  });

  export {StyledTextField};

function AboutYou( { addressAPI, callbackEmployer, callbackScheme, callbackRegion, callbackDateOfBirth, callbackDateJoinedScheme, 
    callbackABS, callbackSalaryStartYear, callbackSalaries, callbackPartTime, callbackRankAtRetirement, callbackIsMemberOfMet, callbackHasUserInputData,
    callbackOptionsToRun, callbackPrevSchemeName, callbackCurrSchemeName, callbackdateOfChosenRetirement,
    callbackAgeSPA, callbackAgeVRA, callbackDeferredAge, callbackRetirementDates, callbackRetirementAges, callbackCareAges,
    callbackCareAgesMinimum, callbackCareAgesMaximum, callbackDateLeftSchemeArray, callbackLeftScheme, callbackMaxCommutationPrevScheme,
    callbackMaxCommutationCurrScheme, callbackCommutationFactorPrevScheme, callbackCommutationFactorCurrScheme,
    callbackChosenCommutationProportionPrevScheme, callbackChosenCommutationProportionCurrScheme,
    callbackAnnualPensionPrevScheme, callbackAnnualPensionCurrScheme, callbackFinalSalary, callbackCpi, callbackInfographicShow,
    callbackInfographicPrevSchemePension, callbackInfographicCurrSchemePensionInPayment, callbackInfographicCurrSchemePensionLaterPayment,
    callbackInfographicPrevSchemePensionNormalised, callbackInfographicCurrSchemePensionInPaymentNormalised,
    callbackInfographicCurrSchemePensionLaterPaymentNormalised, callbackInfographicLumpSum2015, callbackInfographicLumpSum1987,
    callbackInfographicIntroduction, callbackInfographicCareIntroduction, callbackInfographicFinalSalaryCommutation,
    callbackInfographicCareCommutation, callbackTitles, callbackMinDeferredAge, callbackMaxDeferredAge, callbackRealAge,
    callbackAnnualPensionNominal, callbackAnnualPensionReal, callbackAnnualPensionProportional,
    callbackLumpSumNominal, callbackLumpSumReal, callbackLumpSumProportional, callbackCurrentAge,
    callbackLumpSumComparisonChart,
    callbackInfographicPrevSchemePensionEqualised, callbackInfographicCurrSchemePensionInPaymentEqualised, callbackInfographicCurrSchemePensionLaterPaymentEqualised,
    callbackInfographicPrevSchemePensionNormalisedEqualised, callbackInfographicCurrSchemePensionInPaymentNormalisedEqualised,
    callbackInfographicCurrSchemePensionLaterPaymentNormalisedEqualised, callbackInfographicLumpSum2015Equalised, callbackInfographicLumpSum1987Equalised,
    callbackInfographicCareCommutationEqualised,
    callbackInfographicCommutationProportion1987, callbackInfographicCommutationProportion2015,
    callbackInfographicAutoLumpSum, callbackIsNewEntrant, callbackAbsYear, callbackAbsLegacy, callbackRssYears, callbackRssDays, callbackRssLegacyYears, callbackRssLegacyDays} ) 
{
    const [activeStep, setActiveStep] = useState(0);

    const [employer, setEmployer] = useState("NHS");
    const [scheme, setScheme] = useState(null);
    const [region, setRegion] = useState("Scotland");
    const [dateOfBirth, setDateOfBirth] = useState(null);
    const [dateJoinedScheme, setDateJoinedScheme] = useState(null);
    const [dateLeftScheme, setDateLeftScheme] = useState(null);
    const [dateOfChosenRetirement, setdateOfChosenRetirement] = useState(null);
    const [dateOfChosenRetirementValid, setdateOfChosenRetirementValid] = useState(null);
    const [isEligible, setIsEligible] = useState(null);
    const [dateOfBirthValid, setDateOfBirthValid] = useState()
    const [abs, setAbs] = useState("");//Note - placeholder for an ABS input
    const [absLegacy, setAbsLegacy] = useState("");//Note - placeholder for an ABS input
    const [rssYears, setRssYears] = useState("");
    const [rssDays, setRssDays] = useState("");
    const [rssLegacyYears, setRssLegacyYears] = useState("");
    const [rssLegacyDays, setRssLegacyDays] = useState("");
    const [absYear, setAbsYear] = useState(null);
    const [salaryStartYear, setSalaryStartYear] = useState(2015); //Note - placeholder for an ABS input
    const [salaries, setSalaries] = useState([]);
    const [partTime, setPartTime] = useState([{from: null, to: null, proportion: null},]);
    const [fillPartTimeFlag, setFillPartTimeFlag] = useState(false);
    const [partTimeOverlapWarning, setPartTimeOverlapWarning] = useState(false);
    const [isRetired, setIsRetired] = useState("waiting");
    const [hasLeftScheme, setHasLeftScheme] = useState("waiting");
    const [isDateJoinedValid, setIsDateJoinedValid] = useState(false);
    const [isMemberOfMet, setIsMemberOfMet] = useState(false);
    const [rankAtRetirement, setRankAtRetirement] = useState("Constable");
    const [isNewEntrant, setIsNewEntrant] = useState(null);

    const [status, setStatus] = useState({
        special: false,
        mho: false
    });

    const [statusName, setStatusName] = useState("Standard_Officer")
    const [isEligibleSpecial, setIsEligibleSpecial] = useState(false);

    const [loading, setLoading] = useState(false);

    const [currSalary, setCurrSalary] = useState("")
    const [prevSalary, setPrevSalary] = useState("")

    const [validPartTimeFlag, setValidPartTimeFlag] = useState(true);

    // For Date() months are zero indexed
    const schemeDateStatus = new Date(1995, 3, 1)
    const schemeDate2006 = new Date(2008, 3, 1)
    const schemeDate2012 = new Date(2012, 3, 1)
    const schemeDate2015 = new Date(2015, 3, 1)

    //console.log({'activestep': activeStep,'scheme':scheme})

    useEffect(() => {
        window.scrollTo(0, 0);
      }, [activeStep]);

    useEffect(() => {
        handleStatusName();
      }, [scheme, status, dateJoinedScheme]);    

      useEffect(() => {
        handleScheme();
      }, [dateJoinedScheme]); 

      useEffect(() => {
        handleDoB();
      }, [dateOfBirth]);       
  
      useEffect(() => {
        handleIsRetired();
      }, [isRetired]); 
      
      useEffect(() => {
        handleHasLeftScheme();
      }, [hasLeftScheme]); 

      const handleHasLeftScheme = () => {
        if (hasLeftScheme === false) {
            setDateLeftScheme(null)
            // getting rid of placeholder
            setdateOfChosenRetirementValid(false)
            setdateOfChosenRetirement(null)
        }
        if (dateJoinedScheme < schemeDate2012 && (dateJoinedScheme > dateOfBirth) && (hasLeftScheme >= schemeDate2015 || dateLeftScheme === null) && (isRetired !== true )) {
            setIsEligible(true)
            // if the member is eligible and has left we bypass the chosen retirement scenario as only the DPA scenario gets used
            // so just setting this to a placeholder and setting to be valid so next button still appears
            if (hasLeftScheme === true) {
                setdateOfChosenRetirementValid(true)
                setdateOfChosenRetirement(moment(new Date(2099, 12, 1)))}
        } else {
            setIsEligible(false)
        }
    };

    const handleIsRetired = () => {
        setHasLeftScheme("waiting")
        setDateLeftScheme(null)
    };

    const handleStatusChange = (event) => {
        setStatus({
          ...status,
          [event.target.name]: event.target.checked,
        });
      };

      const handleDoB = () => {
        if (dateOfBirth === null || !dateOfBirth['_isValid'] || !dateOfBirthValid) {
            setDateJoinedScheme(null)
            setScheme(null)
            setIsRetired("waiting")
            setHasLeftScheme("waiting")
            setDateLeftScheme(null)
            setStatus({
                special: false,
                mho: false
            }) 
            setdateOfChosenRetirement(null)
        } 
      }

    const {special, mho} = status

    const handleStatusName = () => {
        switch(scheme) {
            case '1995':
                if (status['special'] && status['mho']) {
                    setStatusName("MHO_Special_Class")
                } else if (status['special'] && !status['mho']) {
                    setStatusName("Special_Class")
                } else if (!status['special'] && status['mho']) {
                    setStatusName("MHO")
                } else {
                    setStatusName("Standard_Officer")
                }
                break;
            case '2008':
                setStatusName("Officer")
                break;
            default:
                setStatusName("Standard_Officer")
        }
        if (scheme != null && moment(dateJoinedScheme) >= moment(schemeDate2012)) {
            setIsNewEntrant(true)
        } else {
            setIsNewEntrant(false)
        }
    }

    const handleScheme = () => {
        if (dateJoinedScheme === null || !dateJoinedScheme['_isValid'] || !isDateJoinedValid) {
            setScheme(null)
            setIsRetired("waiting")
            setHasLeftScheme("waiting")
            setDateLeftScheme(null)
            setStatus({
                special: false,
                mho: false
            })
        } else if (dateJoinedScheme < schemeDate2006) {
            setScheme('1995')
            if (dateJoinedScheme < schemeDateStatus) {
                setIsEligibleSpecial(true)
            } else {
                setIsEligibleSpecial(false)
            } 
        } else if (dateJoinedScheme < schemeDate2015) {
            setScheme('2008') 
        } else {
            setScheme('2015')
        }
    };
    
    const handleNext = () => {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      if (activeStep === 2){
          if (partTime[partTime.length-1]['from'] === null || partTime[partTime.length-1]['to'] === null || partTime[partTime.length-1]['proportion'] === '' || partTime[partTime.length-1]['proportion'] === null ) {
            partTime.pop()
          }
      };
    };

    const handleNextEligible = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        var upperDate
        if (hasLeftScheme === false) {
            upperDate = new Date()
        } else {
            upperDate = dateLeftScheme
        }
        const april2015 = schemeDate2015
        const diffTime = Math.abs(upperDate - april2015) // In milliseconds
        const diffYears = Math.ceil(diffTime / (1000 * 60 * 60 * 24 * 365))

        var tempSalaries = []
        for (let i = 0; i < diffYears; i++) {
            tempSalaries.push(0)
        }
        setSalaries(tempSalaries)
    };

    const handleNextSalary = () => {
        let tempSalaries = salaries
        if (prevSalary !== null) {
            tempSalaries[0] = prevSalary
        }
        tempSalaries[tempSalaries.length - 1] = currSalary
        setSalaries(tempSalaries)
        setActiveStep((prevActiveStep) => prevActiveStep + 1)
    };
  
    const handleBack = () => {
      let tempSalaries = salaries
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
      switch(activeStep) {
        case 1:
            setScheme(null)
            setDateOfBirth(null)
            setDateJoinedScheme(null)
            setDateLeftScheme(null)
            setIsRetired("waiting")
            setHasLeftScheme("waiting")
            for (let i = 0; i < tempSalaries.length -1; i++) {
                tempSalaries[i] = 0 
            }
            setSalaries(tempSalaries)
            setAbs(null)
            setAbsLegacy(null)
            setRssYears(null)
            setRssDays(null)
            setRssLegacyYears(null)
            setRssLegacyDays(null)
            setAbsYear(null)
            setCurrSalary("")
            setPrevSalary("")
            setIsNewEntrant(null)
            setHasLeftScheme(null)
            break
        case 2:
            for (let i = 0; i < tempSalaries.length -1; i++) {
                tempSalaries[i] = 0 
            }
            setSalaries(tempSalaries)
            setCurrSalary("")
            setPrevSalary("")

            setPartTime([{from: null, to: null, proportion: null},])
            setFillPartTimeFlag(false)
            setValidPartTimeFlag(true)

            setAbs(null)
            setAbsLegacy(null)
            setRssYears(null)
            setRssDays(null)
            setRssLegacyYears(null)
            setRssLegacyDays(null)
            setAbsYear(null)
            break
        case 3:
            setPartTime([{from: null, to: null, proportion: null},])
            setFillPartTimeFlag(false)
            setValidPartTimeFlag(true)
            setIsMemberOfMet(false);
            break
        case 4:

            setIsMemberOfMet(false);

            break;
        default:

      }
    };

    const history = useHistory();

    const convertDateToUTC = (dateObj) => {
        return dateObj !== null ? dateObj.add(dateObj.utcOffset(),"minutes") : dateObj
    }
  
    const handleSubmit = async () => {

        setLoading(true)

        const data = {
            "employer" : employer,
            "scheme" : scheme,
            "region" : region,
            "dateOfBirth" : convertDateToUTC(dateOfBirth),
            "dateJoinedScheme" : convertDateToUTC(dateJoinedScheme),
            "dateLeftScheme" : convertDateToUTC(dateLeftScheme),
            "dateOfChosenRetirement" : convertDateToUTC(dateOfChosenRetirement),
            "ABS" : abs,
            "absLegacy" : absLegacy,
            "rssYears" : rssYears,
            "rssDays" : rssDays,
            "rssLegacyYears" : rssLegacyYears,
            "rssLegacyDays" : rssLegacyDays,
            "absYear": absYear != null ? absYear.year() : null,
            "salaryStartYear" : salaryStartYear,
            "salaries" : salaries,
            "partTime" : partTime,
            "rankAtRetirement" : rankAtRetirement,
            "isMemberOfMet" : isMemberOfMet,
            "statusName": statusName,
            "isNewEntrant": isNewEntrant
        }

        console.log(data)

        const requestOptions = {
            method: 'Post',
            headers: {'Content-Type' : 'application/json'},
            body: JSON.stringify(data)
        }

        console.log(JSON.stringify(data))

        let address = addressAPI + "api/setup"
        fetch(address, requestOptions)
        .then(response => response.json())
        .then(function (data) {
            //console.log(data)
            callbackEmployer(employer)
            callbackScheme(scheme)
            callbackRegion(region)
            callbackDateOfBirth(dateOfBirth)
            callbackDateJoinedScheme(dateJoinedScheme)
            callbackdateOfChosenRetirement(dateOfChosenRetirement)
            callbackABS(abs)
            callbackSalaryStartYear(salaryStartYear)
            callbackSalaries(salaries)
            callbackPartTime(partTime)
            callbackRankAtRetirement(rankAtRetirement)
            callbackIsMemberOfMet(isMemberOfMet)
            callbackPrevSchemeName(data['constants']['prevSchemeName'])
            callbackCurrSchemeName(data['constants']['currSchemeName'])
            callbackAgeSPA(data['constants']['SPA'])
            callbackAgeVRA(data['constants']['VRA'])
            callbackDeferredAge(data['scenarioParameters']['deferredAge'])
            callbackCurrentAge(data['constants']['currentAge'])
            callbackRetirementDates(data['scenarioParameters']['retirementDate'])
            callbackRetirementAges(data['scenarioParameters']['retirementAge'])
            callbackCareAges(data['scenarioParameters']['careAge'])
            callbackCareAgesMinimum(data['scenarioParameters']['careAgeMinimum'])
            callbackCareAgesMaximum(data['scenarioParameters']['careAgeMaximum'])
            callbackDateLeftSchemeArray(data['scenarioParameters']['dateLeftScheme'])
            callbackLeftScheme(data['scenarioParameters']['leftScheme'])
            callbackMaxCommutationPrevScheme(data['scenarioParameters']['maxCommutationPrevScheme'])
            callbackMaxCommutationCurrScheme(data['scenarioParameters']['maxCommutationCurrScheme'])
            callbackCommutationFactorPrevScheme(data['scenarioParameters']['commutationFactorPrevScheme'])
            callbackCommutationFactorCurrScheme(data['scenarioParameters']['commutationFactorCurrScheme'])
            callbackChosenCommutationProportionPrevScheme(data['scenarioParameters']['chosenCommutationProportionPrevScheme'])
            callbackChosenCommutationProportionCurrScheme(data['scenarioParameters']['chosenCommutationProportionCurrScheme'])
            callbackAnnualPensionPrevScheme(data['scenarioParameters']['annualPensionPrevScheme'])
            callbackAnnualPensionCurrScheme(data['scenarioParameters']['annualPensionCurrScheme'])
            callbackFinalSalary(data['scenarioParameters']['finalSalary'])
            callbackCpi(data['cpi'])
            callbackInfographicPrevSchemePension(data['infographicData']['1987 Pension'])
            callbackInfographicCurrSchemePensionInPayment(data['infographicData']['2015 Pension - In Payment'])
            callbackInfographicCurrSchemePensionLaterPayment(data['infographicData']['2015 Pension - Later Payment'])
            callbackInfographicPrevSchemePensionNormalised(data['infographicData']['1987 Pension normalised'])
            callbackInfographicCurrSchemePensionInPaymentNormalised(data['infographicData']['2015 Pension - In Payment normalised'])
            callbackInfographicCurrSchemePensionLaterPaymentNormalised(data['infographicData']['2015 Pension - Later Payment normalised'])
            callbackInfographicLumpSum2015(data['infographicData']['lumpSum2015'])
            callbackInfographicLumpSum1987(data['infographicData']['lumpSum1987'])
            callbackInfographicPrevSchemePensionEqualised(data['infographicData']['1987 Pension Equalised'])
            callbackInfographicCurrSchemePensionInPaymentEqualised(data['infographicData']['2015 Pension - In Payment Equalised'])
            callbackInfographicCurrSchemePensionLaterPaymentEqualised(data['infographicData']['2015 Pension - Later Payment Equalised'])
            callbackInfographicPrevSchemePensionNormalisedEqualised(data['infographicData']['1987 Pension normalised Equalised'])
            callbackInfographicCurrSchemePensionInPaymentNormalisedEqualised(data['infographicData']['2015 Pension - In Payment normalised Equalised'])
            callbackInfographicCurrSchemePensionLaterPaymentNormalisedEqualised(data['infographicData']['2015 Pension - Later Payment normalised Equalised'])
            callbackInfographicLumpSum2015Equalised(data['infographicData']['lumpSum2015 Equalised'])
            callbackInfographicLumpSum1987Equalised(data['infographicData']['lumpSum1987 Equalised'])
            callbackInfographicIntroduction(data['infographicData']['introduction'])
            callbackInfographicCareIntroduction(data['infographicData']['careIntroduction'])
            callbackInfographicFinalSalaryCommutation(data['infographicData']['finalSalaryCommutation'])
            callbackInfographicCareCommutation(data['infographicData']['careCommutation'])
            callbackInfographicCareCommutationEqualised(data['infographicData']['careCommutation Equalised'])
            callbackTitles(data['titles'])
            callbackMinDeferredAge(data['minDeferredAge'])
            callbackMaxDeferredAge(data['maxDeferredAge'])
            callbackAnnualPensionNominal(data['annualPension_nominal'])
            callbackAnnualPensionReal(data['annualPension_real'])
            callbackAnnualPensionProportional(data['annualPension_proportion'])
            callbackLumpSumNominal(data['lumpSum_nominal'])
            callbackLumpSumReal(data['lumpSum_real'])
            callbackLumpSumProportional(data['lumpSum_proportion'])
            callbackLumpSumComparisonChart(data['lumpSum_comparison'])
            callbackInfographicAutoLumpSum(data['infographicData']['auto_lumpsum'])
        
            callbackHasUserInputData(true)

            callbackMaxCommutationPrevScheme(data['scenarioParameters']['maxCommutationPrevScheme'])

            if (data['scenarioParameters']['leftScheme'].length ===1 && data['scenarioParameters']['leftScheme'][0] === true ) {
                callbackInfographicShow(false)
            } else{
                callbackInfographicShow(true)
            }

            callbackIsNewEntrant(isNewEntrant)
            callbackAbsYear(absYear)
            callbackAbsLegacy(absLegacy)
            callbackRssLegacyYears(rssLegacyYears)
            callbackRssLegacyDays(rssLegacyDays)
            callbackRssYears(rssYears)
            callbackRssDays(rssDays)

            data['infographicData']['auto_lumpsum'] && callbackInfographicCommutationProportion1987(1)
            data['infographicData']['auto_lumpsum'] && callbackInfographicCommutationProportion2015(0)
            
            setLoading(false)
            history.push("your summary")

        }).catch(function (error) {
            console.log(error);
        });
    };

    const handleDateChange = (newDate, setDate, flag) => {
        const minDate = schemeDate2012
        const maxDate = schemeDate2015
        //console.log(flag)
        //newDate =  moment(newDate).add(1,'hour')
        //console.log(newDate)
        setDate(newDate)
        if (flag === "joined") {
            if (moment(newDate) - moment(dateOfBirth) - 504921600000 >= 0) {
                setIsDateJoinedValid(true)
            } else {
                setIsDateJoinedValid(false)
            }
            if (newDate < minDate && (newDate > dateOfBirth) && (dateLeftScheme >= maxDate || dateLeftScheme === null) && (isRetired !== true )) {
                setIsEligible(true)
            } else {
                setIsEligible(false)
            }
        } 
        
        if (flag === "left" && newDate !== null) {
            //console.log({'period from 16 - left': moment(dateJoinedScheme) - moment(dateOfBirth) - 504921600000})
            if (moment(dateJoinedScheme) - moment(dateOfBirth) - 504921600000 >= 0) {
                setIsDateJoinedValid(true)
            } else {
                setIsDateJoinedValid(false)
            }
            if (dateJoinedScheme < minDate && (dateJoinedScheme > dateOfBirth) && (newDate >= maxDate || dateLeftScheme === null) && (isRetired !== true )) {
                setIsEligible(true)
            } else {
                setIsEligible(false)
            }
        }

        if (flag === "birth" && newDate !== null) {
            if (newDate['_isValid']) {
                //console.log({'period from 16 - birth': moment(dateJoinedScheme) - moment(newDate) - 504921600000})
                if (moment(dateJoinedScheme) - moment(newDate) - 504921600000 >= 0) {
                    setIsDateJoinedValid(true)
                } else {
                    setIsDateJoinedValid(false)
                }                
                if (newDate < moment(new Date() - yearsToMilliseconds(75)) || newDate.isBefore(earliestDoBSPADate) ) { // 75 years in milliseconds
                    setDateOfBirthValid(false)
                    setIsEligible(false)
                } else {
                    setDateOfBirthValid(true)
                    if (dateJoinedScheme < minDate && (dateJoinedScheme > dateOfBirth) && (dateLeftScheme >= maxDate || dateLeftScheme === null) && (isRetired !== true )) {
                        setIsEligible(true)
                    } else {
                        setIsEligible(false)
                    }
                }

            }
        }

        if (flag === "retirement" && newDate !== null) {
            if (newDate['_isValid']) {
                if ((newDate >= moment(new Date()).startOf('day')) && (newDate >= moment(dateOfBirth + yearsToMilliseconds(50) - 43200000)) && (newDate < moment(dateOfBirth + yearsToMilliseconds(75) + 43200000))) {
                    setdateOfChosenRetirementValid(true)
                } else {
                    setdateOfChosenRetirementValid(false)
                }                
            }
        }
    };

    const handleSalaryInput = (event, setValue) => {
        if(event.target.value === "") {
            setValue("");
        } else if ( ! isNaN(Number(event.target.value)) ) {
            if (event.target.value < 0) {
                setValue(0)
            } else {
                setValue(Number(event.target.value))
            }
        }        
    };

    const handleAddPartTimeField = (index) => {

        if (partTime[index]['from'] === null || partTime[index]['to'] === null || partTime[index]['proportion'] === null) {
            setFillPartTimeFlag(true)
        } else {
            setPartTime([...partTime, {from: null, to: null, proportion:null}])
            setFillPartTimeFlag(false)
        }
    };

    const handleHasNotLeftScheme = () =>{
        setHasLeftScheme(false)
        setDateLeftScheme(null)
        //getting rid of the placeholder date of chosen retirement
        setdateOfChosenRetirementValid(false)
        setdateOfChosenRetirement(null)
    }

    const handleRankAtRetirementChange = (event) => {
        setRankAtRetirement(event.target.value)
    }

    const yearsToMilliseconds = (years) => {
        return years * 31556952000
    }

    const earliestABSYear = Math.max(isNewEntrant ? 2016 : 2022, moment(dateJoinedScheme).month() < 3 ? moment(dateJoinedScheme).year() - 1 : moment(dateJoinedScheme).year())
    // prior to this date, SPA differs based on gender - we are not allowing for this so the DOB has to be later
    const earliestDoBSPADate = moment('1953-12-06')

    console.log({
        'scheme':scheme,
        'isEligible':isEligible,
        'dateJoinedScheme':dateJoinedScheme,
        'dateLeftScheme':dateLeftScheme,
        'dateOdBirth':dateOfBirth,
        'dateOfBirthValid':dateOfBirthValid,
        'isRetired':isRetired,
        'hasLeftScheme':hasLeftScheme,
        'schemeDate2006':schemeDate2006,
        'isDateJoinedValid':isDateJoinedValid,
        'partTime':partTime,
        'fillPartTimeFlag':fillPartTimeFlag,
        'validPartTimeFlag':validPartTimeFlag,
        'isNewEntrant':isNewEntrant,
        'ABSYear': absYear,
        'earliestABSYear':earliestABSYear,
        'dateOfChosenRetirement':dateOfChosenRetirement,
        'dateOfChosenRetirementValid':dateOfChosenRetirementValid,
    })

    return (
            <div className="aboutyou__body">
                {loading === true ? (
                    <div id="loading"/>
                ) : (
                    null
                )}
                <div className="aboutyou__stepper__container">
                    <Box sx={{ width: '100%' }}>
                        <div className="stepper__topbar">
                        <Stepper activeStep={activeStep} alternativeLabel connector={<StyledConnector />}>
                            {steps.map((label, index) => {
                            const stepProps = {};
                            const labelProps = {};
                            return (
                                <Step key={label} {...stepProps}>
                                <StepLabel StepIconComponent={StyledIcon} {...labelProps}>{label}</StepLabel>
                                </Step>
                            );
                            })}
                        </Stepper>
                        </div>
                        
                        {activeStep === 0 ? (
                            
                            <div className="radio__container">
                                <React.Fragment>
                                    <Typography sx={{ mt: 2, mb: 1 }}>Please enter your date of birth and date you joined the pension scheme</Typography>
                                    <LocalizationProvider dateAdapter={DateAdapter}>
                                        <ThemeProvider theme={themeGAD}>
                                            <div className="calendar__container">
                                                <DesktopDatePicker 
                                                label="Date of birth"
                                                inputFormat="DD/MM/yyyy"
                                                value={dateOfBirth}
                                                minDate={
                                                    moment(new Date() - yearsToMilliseconds(75) - 43200000).isAfter(earliestDoBSPADate) ? 
                                                    moment(new Date() - yearsToMilliseconds(75) - 43200000) :
                                                    earliestDoBSPADate
                                                }
                                                // minDate={moment(new Date() - yearsToMilliseconds(75) - 43200000)}
                                                maxDate={moment(new Date() - yearsToMilliseconds(16) + 43200000)}
                                                onChange={(date) => handleDateChange(date, setDateOfBirth, "birth")}
                                                renderInput={(params) => <TextField {...params}/>}
                                                />
                                                {dateOfBirthValid === false && (
                                                    <Typography sx={{ mt: 2, mb: 1 }}>The maximum age for this calculator is 75. Your date of birth must be after 6 December 1953 to use this calculator.
                                                    </Typography>
                                                )}
                                            </div>
                                            {dateOfBirth !== null ? (
                                                dateOfBirth['_isValid'] && dateOfBirthValid === true ? (
                                                    <div className="calendar__container">   
                                                    <DesktopDatePicker
                                                    label="Date joined scheme"
                                                    inputFormat="DD/MM/yyyy"
                                                    value={dateJoinedScheme}
                                                    minDate={moment(dateOfBirth + yearsToMilliseconds(16) - 43200000)}
                                                    maxDate={moment(new Date())}
                                                    onChange={(date) => handleDateChange(date, setDateJoinedScheme, "joined")}
                                                    renderInput={(params) => <TextField {...params}/>}
                                                    />
                                                </div>
                                                ) : (
                                                    <div className="calendar__container">   
                                                    <DesktopDatePicker
                                                    label="Date joined scheme"
                                                    inputFormat="DD/MM/yyyy"
                                                    value={dateJoinedScheme}
                                                    minDate={moment(dateOfBirth + yearsToMilliseconds(16) - 43200000)}
                                                    maxDate={moment(new Date())}
                                                    onChange={(date) => handleDateChange(date, setDateJoinedScheme, "joined")}
                                                    renderInput={(params) => <TextField {...params}/>}
                                                    disabled
                                                    />
                                                </div>  
                                                )

                                            ) : (
                                            <div className="calendar__container">   
                                                <DesktopDatePicker
                                                label="Date joined scheme"
                                                inputFormat="DD/MM/yyyy"
                                                value={dateJoinedScheme}
                                                minDate={moment(dateOfBirth + yearsToMilliseconds(16) - 43200000)}
                                                maxDate={moment(new Date())}
                                                onChange={(date) => handleDateChange(date, setDateJoinedScheme, "joined")}
                                                renderInput={(params) => <TextField {...params}/>}
                                                disabled
                                                />
                                            </div>        
                                            )}
   
                                            {moment(dateJoinedScheme).valueOf() - moment(dateOfBirth).valueOf() < yearsToMilliseconds(16) && (
                                            <Typography sx={{ mt: 2, mb: 1 }}>You must have been at least 16 years old when you joined the scheme.</Typography>
                                            )}

                                            {isDateJoinedValid && (
                                                <div>
                                                    <Typography sx={{ mt: 2, mb: 1 }}>From the information you have provided you appear to be in the {scheme} scheme.</Typography>
                                                    {scheme === '1995' && isEligibleSpecial && (
                                                        <div>
                                                            {/* <Typography sx={{ mt: 2, mb: 1 }}>Select any special or MHO statuses you have before clicking Next</Typography>  */}
                                                            <Typography sx={{ mt: 2, mb: 1 }}>If you have special status please check the box below before clicking Next</Typography> 
                                                            <FormControl  component="fieldset" variant="standard">
                                                                <FormGroup>
                                                                <FormControlLabel
                                                                    control={
                                                                    <Checkbox checked={special} onChange={handleStatusChange} name="special" sx={{
                                                                        color: colorTheme,
                                                                        '&.Mui-checked': {
                                                                        color: colorTheme,
                                                                        },}}/>
                                                                    }
                                                                    label="Special Class"
                                                                />
                                                                {/* <FormControlLabel
                                                                    control={
                                                                    <Checkbox checked={mho} onChange={handleStatusChange} name="mho" sx={{
                                                                        color: colorTheme,
                                                                        '&.Mui-checked': {
                                                                        color: colorTheme,
                                                                        },}}/>
                                                                    }
                                                                    label="Mental Health Officer"
                                                                /> */}
                                                                </FormGroup>
                                                            </FormControl>
                                                        </div>
                                                    )}
                                                </div>
                                                
                                            )} 

                                            {scheme != null && 
                                            (<>
                                            <Typography sx={{ mt: 2, mb: 1 }}>Are you currently in receipt of your NHS pension, through full or partial retirement?</Typography>
                                            <div className="radiobuttons__region">
                                                <FormControl component="fieldset">
                                                    <RadioGroup row
                                                        aria-label="retired"
                                                        name="radio-buttons-group">
                                                        <FormControlLabel 
                                                        value="yes" 
                                                        control={<Radio style={{color:colorTheme}} />} 
                                                        label="Yes"
                                                        onClick={() => setIsRetired(true)} />
                                                        <FormControlLabel 
                                                        value="no" 
                                                        control={<Radio style={{color:colorTheme}} />} 
                                                        label="No"
                                                        onClick={() => setIsRetired(false)} />
                                                    </RadioGroup>
                                                    {!isRetired ? (
                                                    <div>
                                                    <Typography sx={{ mt: 2, mb: 1 }}>Have you opted out of the pension scheme or have you left service?</Typography>
                                                    <RadioGroup row
                                                        aria-label="leftScheme"
                                                        name="radio-buttons-group">
                                                        <FormControlLabel 
                                                        value="yes" 
                                                        control={<Radio style={{color:colorTheme}} />} 
                                                        label="Yes"
                                                        onClick={() => setHasLeftScheme(true)} />
                                                        <FormControlLabel 
                                                        value="no" 
                                                        control={<Radio style={{color:colorTheme}} />} 
                                                        label="No"
                                                        onClick={() => handleHasNotLeftScheme() }/>
                                                    </RadioGroup>
                                                    </div>
                                                    ) : isRetired === true ? (
                                                        dateJoinedScheme < schemeDate2012 ?
                                                        (<Typography sx={{ mt: 2, mb: 1 }}>As you have already retired your pension administrator will be in touch regarding McCloud Remedy if you are impacted.</Typography>) : (
                                                        <Typography sx={{ mt: 2, mb: 1 }}>You have told us that you have retired. This tool does not provide projections for retired members, please contact your pension administrator if you have any questions regarding your pension benefits.</Typography>
                                                        )
                                                    ) : isRetired === "waiting" && (
                                                        null
                                                    )}
                                                    {hasLeftScheme === true && isRetired === false && scheme === '1995' ? (
                                                    <div className="calendar__container">
                                                        <Typography sx={{ mt: 2, mb: 1 }} style={{marginTop:"0px"}}>When did you leave the pension scheme?</Typography>
                                                        <DesktopDatePicker
                                                        label="Date left scheme"
                                                        inputFormat="DD/MM/yyyy"
                                                        value={dateLeftScheme}
                                                        minDate={moment(dateJoinedScheme)}
                                                        onChange={(date) => handleDateChange(date, setDateLeftScheme, "left")}
                                                        renderInput={(params) => <TextField {...params}/>}
                                                        />
                                                    </div> 
                                                    ) : hasLeftScheme === true && isRetired === false ? (
                                                        <Typography sx={{ mt: 2, mb: 1 }}>You have told us that you have left the {scheme} scheme. This tool does not provide projections for leavers of your scheme, please contact your pension administrator if you have any questions regarding your pension benefits.</Typography>
                                                    ) : hasLeftScheme === "waiting" && (
                                                        null
                                                    )}
                                                </FormControl>
                                            </div>
                                            </>)}
                                        {/* remove this block when 2006 scheme option is added into tool */}

                                        {/* add this block back in once 2006 scheme option added into tool */}
                                        {dateJoinedScheme !== null && scheme === "1995" && dateJoinedScheme >= schemeDate2006 && dateJoinedScheme < schemeDate2015 && (
                                            <Typography sx={{ mt: 2, mb: 1 }}>We would expect members to have joined on or after 1 April 2008 to be members of the 2008 scheme. You have told us you are in the 1995 scheme.</Typography>
                                        )}
                                        {dateJoinedScheme !== null && scheme === "1995" && (status.special || status.mho) &&  dateJoinedScheme >= schemeDateStatus && (
                                            <Typography sx={{ mt: 2, mb: 1 }}>We would not expect members who have joined on or after 1 April 1995 to have either Special Class or MHO status. You have told us you have {status.special && status.mho ? "both Special Class and MHO" : status.special ? "Special Class" : "MHO"} status.</Typography>
                                        )}                                        
                                        {dateJoinedScheme !== null && scheme === "2008" && dateJoinedScheme < schemeDate2006 && (
                                            <Typography sx={{ mt: 2, mb: 1 }}>We would expect members to have joined before 1 April 2008 to be members of the 1995 scheme. You have told us you are in the 2008 scheme.</Typography>
                                        )}  

                                        
                                        {dateLeftScheme != null && dateJoinedScheme != null && dateLeftScheme < dateJoinedScheme && (
                                            <Typography sx={{ mt: 2, mb: 1 }}>Date of leaving cannot be before date of joining.</Typography>
                                        )}

                                        {dateJoinedScheme >= schemeDate2012 && isRetired !== "waiting" && ((hasLeftScheme === false) || (hasLeftScheme === true && dateLeftScheme != null && dateLeftScheme >= dateJoinedScheme)) ? 
                                            dateLeftScheme != null && dateLeftScheme < schemeDate2015 ? (
                                                <Typography sx={{ mt: 2, mb: 1 }}>This calculator does not produce projections for members leaving before 1 April 2015 who joined after 1 April 2012.</Typography>
                                            ) : (
                                                <Typography sx={{ mt: 2, mb: 1 }}>Please select a retirement age and click "next" to continue.</Typography>
                                            ) : (
                                            <></>
                                        )}                                 

                                        {dateJoinedScheme < schemeDate2012 && 
                                            (
                                                dateOfBirth !== null && dateJoinedScheme !== null && isRetired === false && 
                                                (
                                                    (hasLeftScheme === false) ? 
                                                    (
                                                        ((scheme === "1995" && !((status.special || status.mho) &&  dateJoinedScheme >= schemeDateStatus)) || (scheme === "2008") ) && 
                                                            (
                                                                isEligible === true ? (
                                                                    <Typography sx={{ mt: 2, mb: 1 }}>You are eligible for McCloud remedy, please select a retirement age and click "next" to continue.</Typography>
                                                                ) : (
                                                                    <Typography sx={{ mt: 2, mb: 1 }}>Based on your inputs, we believe you are not eligible for McCloud remedy. However we are able to provide you with a projection of your current benefits. <br/><br/> If you have any questions regarding eligibility, please contact your pension administrator </Typography>
                                                                )  
                                                            )
                                                    )
                                                    : (hasLeftScheme === true) && 
                                                    (
                                                        ((scheme === "1995" && !((status.special || status.mho) &&  dateJoinedScheme >= schemeDateStatus)) && dateLeftScheme >= schemeDate2015 && isDateJoinedValid === true) ?
                                                            (
                                                                isEligible === true ? (
                                                                    <Typography sx={{ mt: 2, mb: 1 }}>You are eligible for McCloud remedy, please click "next" to continue.</Typography>
                                                                ) : (
                                                                    <Typography sx={{ mt: 2, mb: 1 }}>Based on your inputs, we believe you are not eligible for McCloud remedy. However we are able to provide you with a projection of your current benefits. <br/><br/> If you have any questions regarding eligibility, please contact your pension administrator </Typography>
                                                                )  
                                                            ) : dateLeftScheme != null && (
                                                                <Typography sx={{ mt: 2, mb: 1 }}>Based on your inputs, we believe you are not eligible for McCloud remedy as you have left the secheme proir to 1 April 2015.<br/><br/> If you have any questions regarding eligibility, please contact your pension administrator </Typography>
                                                            )
                                                    ) 
                                                )
                                            )
                                        }
                                        {scheme != null && dateJoinedScheme != null && isRetired === false && hasLeftScheme === false && isDateJoinedValid === true && (
                                                <div>
                                                <Typography sx={{ mt: 2, mb: 1 }}>When do you plan to retire? 
                                                    <br></br>
                                                    Please note that to select a retirement age
                                                    earlier than age 55, you should ensure this is possible in your scheme and that you meet the eligibility criteria.
                                                    Information about retirement ages can be found <a href="https://pensions.gov.scot/nhs/ready-retirement/planning-retirement">here</a>. 
                                                </Typography>
                                                <div className="calendar__container">
                                                    <DesktopDatePicker
                                                    label="Date of chosen retirement"
                                                    inputFormat="DD/MM/yyyy"
                                                    value={dateOfChosenRetirement}
                                                    minDate={
                                                        moment(dateOfBirth + yearsToMilliseconds(50) - 43200000).isAfter(moment(new Date())) ? 
                                                        moment(dateOfBirth + yearsToMilliseconds(50) - 43200000) :
                                                        moment(new Date())
                                                    }
                                                    maxDate={moment(dateOfBirth + yearsToMilliseconds(75) + 43200000)}
                                                    onChange={(date) => handleDateChange(date, setdateOfChosenRetirement, "retirement")}
                                                    renderInput={(params) => <TextField {...params}/>}
                                                    />
                                                </div> 
                                                </div>
                                                ) 
                                        }
                                        {(moment(dateOfChosenRetirement).valueOf() - moment(dateOfBirth).valueOf() < yearsToMilliseconds(50) || moment(dateOfChosenRetirement).valueOf() < moment(new Date()).startOf('day').valueOf()) && hasLeftScheme === false && (
                                        <Typography sx={{ mt: 2, mb: 1 }}>You must be at least 50 years old at the chosen retirement date. The chosen retirement date must be on or after today's date.</Typography>
                                        )}
                                        {moment(dateOfChosenRetirement).valueOf() - moment(dateOfBirth).valueOf() > yearsToMilliseconds(75) && hasLeftScheme === false && (
                                        <Typography sx={{ mt: 2, mb: 1 }}>You must be 75 years old or younger at the chosen retirement date.</Typography>
                                        )}
                                        <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                                            <Button variant="outlined"
                                            color="inherit"
                                            disabled={activeStep === 0}
                                            onClick={handleBack}
                                            sx={{ mr: 1 }}
                                            >
                                            Back
                                            </Button>
                                         <Box sx={{ flex: '1 1 auto' }} />

                                         {scheme != null && dateJoinedScheme != null && isRetired === false && ((hasLeftScheme === false) || (scheme === '1995' && hasLeftScheme === true && dateLeftScheme != null && dateLeftScheme >= schemeDate2015 && dateLeftScheme >= dateJoinedScheme)) && isDateJoinedValid === true && dateOfChosenRetirementValid === true ?  (
                                             <Button variant="outlined" style={{color:colorTheme,border:colorTheme,borderStyle:'solid',borderWidth:'1px'}}  onClick={handleNextEligible}>
                                             {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                                             </Button>
                                         ): (
                                             <Button variant="outlined"
                                             style={{color:"rgb(198,198,198)"}}
                                             disabled
                                             onClick={handleNext}>
                                             {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                                             </Button>
                                         )}

                                     </Box>
                                     </ThemeProvider>
                                    </LocalizationProvider>
                                </React.Fragment>
                            </div>


                        ) : activeStep === 1 ? (
                            
                            <div className="radio__container">
                                <React.Fragment>
                                
                                <Typography sx={{ mt: 2, mb: 1 }}>Tell us about your earnings</Typography>
                                {scheme !== '2015' && <Typography sx={{ mt: 2, mb: 1 }}>If salary as at 1st April 2015 is unknown then leave this blank</Typography>}
                                <Typography sx={{ mt: 2, mb: 1 }}>This should be pensionable earnings and should be the Full-Time Equivalent amount rounded to the nearest pound</Typography>
                                {/* {region === 'England & Wales' && <Typography sx={{ mt: 2, mb: 1 }}>Pensionable pay in the police currently includes basic salary, London weighting and additional salary on temporary promotion. It does not include the London Allowance.</Typography>} */}
                                
                                {hasLeftScheme === true ? (
                                    <StyledTextField className="input__salary" 
                                    label="Salary as at Date Left Scheme (£)" 
                                    variant="standard" 
                                    style={{marginTop:"10px"}}
                                    value={currSalary} 
                                    onChange={event => handleSalaryInput(event, setCurrSalary)}
                                    />
                                ) : (
                                    <StyledTextField className="input__salary" 
                                    label="Current Salary (£)" 
                                    variant="standard" 
                                    style={{marginTop:"10px"}}
                                    value={currSalary} 
                                    onChange={event => handleSalaryInput(event, setCurrSalary)}
                                    />
                                )}
                                {scheme !== '2015' &&
                                <StyledTextField className="input__salary" 
                                    label="Salary as at 1st April 2015 (£)" 
                                    variant="standard" 
                                    style={{marginTop:"10px", marginBottom:"10px"}} 
                                    value={prevSalary} 
                                    onChange={event => handleSalaryInput(event, setPrevSalary)}
                                    />}
                                
                                {<LocalizationProvider dateAdapter={DateAdapter}>
                                <ThemeProvider theme={themeGAD}>
                                <div>
                                    <br></br>
                                    {isNewEntrant && <Typography sx={{ mt: 2, mb: 1 }} style={{marginTop:"0px"}}>Optional:<br />If you would like the illustrator to use the values in your annual benefit statement (ABS), please enter the year on your latest ABS. Otherwise leave it blank.</Typography>}
                                    {!isNewEntrant && <Typography sx={{ mt: 2, mb: 1 }} style={{marginTop:"0px"}}>Optional:<br />If you would like the illustrator to use the values in your annual benefit and remedial service statement (ABS-RSS), please enter the year on your latest ABS-RSS. Otherwise leave it blank.</Typography>}
                                    <Typography sx={{ mt: 2, mb: 1 }}>If you do not enter these values, the illustrator will estimate them.</Typography>
                                    <DesktopDatePicker
                                    label={isNewEntrant ? "ABS year" : "ABS-RSS year"} 
                                    views={(['year'])}
                                    value={absYear}
                                    minDate={moment(new Date(earliestABSYear, 3, 1)) }
                                    maxDate={moment(new Date(moment(new Date()).month() < 3 ? moment(new Date()).year() - 1 : moment(new Date()).year(), 3, 1)) }
                                    onChange={(date) => handleDateChange(date, setAbsYear, "abs")}
                                    renderInput={(params) => <TextField {...params}/>}
                                    />
                                </div>
                                </ThemeProvider>
                                </LocalizationProvider>}
                                {(absYear !== null) && !isNewEntrant && <Typography sx={{ mt: 2, mb: 1 }}>Please enter your 2015 CARE Scheme pension rounded to the nearest pound from your most recent ABS-RSS for the legacy scenario (referred to as 'current' benefits in your ABS-RSS) where you transition to the 2015 CARE Scheme in 2022</Typography>}  
                                {(absYear !== null) && !isNewEntrant &&
                                <StyledTextField className="input__salary" 
                                    label="2015 CARE Scheme pension following transition in 2022 (£)" 
                                    variant="standard" 
                                    style={{marginTop:"10px", marginBottom:"10px"}} 
                                    value={absLegacy} 
                                    onChange={event => handleSalaryInput(event, setAbsLegacy)}
                                    />
                                }
                                {(absYear !== null) && !isNewEntrant && <Typography sx={{ mt: 2, mb: 1 }}>Please enter your legacy scheme pensionable service from your most recent ABS-RSS for the legacy scenario (referred to as 'current' benefits in your ABS-RSS) where you transition to the 2015 CARE Scheme in 2022.</Typography>}
                                {(absYear !== null) && <Typography sx={{ mt: 2, mb: 1 }}>You can enter service in years or days, or a combination of both.</Typography>}  
                                {(absYear !== null) && !isNewEntrant &&
                                <StyledTextField className="input__salary" 
                                    label="Years of legacy service to 2022" 
                                    variant="standard" 
                                    style={{marginTop:"10px", marginBottom:"10px"}} 
                                    value={rssLegacyYears} 
                                    onChange={event => handleSalaryInput(event, setRssLegacyYears)}
                                    />
                                }
                                {(absYear !== null) && !isNewEntrant &&
                                <StyledTextField className="input__salary" 
                                    label="Days of legacy service to 2022" 
                                    variant="standard" 
                                    style={{marginTop:"10px", marginBottom:"10px"}} 
                                    value={rssLegacyDays} 
                                    onChange={event => handleSalaryInput(event, setRssLegacyDays)}
                                    />
                                }
                                {(absYear !== null) && isNewEntrant && (dateJoinedScheme >= schemeDate2015) && <Typography sx={{ mt: 2, mb: 1 }}>Please enter your 2015 CARE Scheme pension rounded to the nearest pound from your most recent ABS</Typography>} 
                                {(absYear !== null) && isNewEntrant && (dateJoinedScheme < schemeDate2015) && <Typography sx={{ mt: 2, mb: 1 }}>Please enter your 2015 CARE Scheme pension rounded to the nearest pound from your most recent ABS</Typography>}
                                {(absYear !== null) && !isNewEntrant && <Typography sx={{ mt: 2, mb: 1 }}>Please enter your 2015 CARE Scheme pension rounded to the nearest pound from your most recent ABS-RSS for the reformed scenario (referred to as 'alternative' benefits in your ABS-RSS) where you transition to the 2015 CARE Scheme in 2015</Typography>}  
                                {(absYear !== null) && 
                                <StyledTextField className="input__salary" 
                                    label="2015 CARE Scheme pension following transition in 2015 (£)" 
                                    variant="standard" 
                                    style={{marginTop:"10px", marginBottom:"10px"}} 
                                    value={abs} 
                                    onChange={event => handleSalaryInput(event, setAbs)}
                                    />
                                }
                                {(absYear !== null) && isNewEntrant && (dateJoinedScheme < schemeDate2015) && <Typography sx={{ mt: 2, mb: 1 }}>Please enter your legacy scheme pensionable service from your most recent ABS.</Typography>}
                                {(absYear !== null) && !isNewEntrant && <Typography sx={{ mt: 2, mb: 1 }}>Please enter your legacy scheme pensionable service from your most recent ABS-RSS for the reformed scenario (referred to as 'alternative' benefits in your ABS-RSS) where you transition to the 2015 CARE Scheme in 2015.</Typography>}  
                                {(absYear !== null) && <Typography sx={{ mt: 2, mb: 1 }}>You can enter service in years or days, or a combination of both.</Typography>}
                                {(absYear !== null) && (dateJoinedScheme < schemeDate2015) &&
                                <StyledTextField className="input__salary" 
                                    label="Years of legacy service to 2015" 
                                    variant="standard" 
                                    style={{marginTop:"10px", marginBottom:"10px"}} 
                                    value={rssYears} 
                                    onChange={event => handleSalaryInput(event, setRssYears)}
                                    />
                                }
                                {(absYear !== null) && (dateJoinedScheme < schemeDate2015) &&
                                <StyledTextField className="input__salary" 
                                    label="Days of legacy service to 2015" 
                                    variant="standard" 
                                    style={{marginTop:"10px", marginBottom:"10px"}} 
                                    value={rssDays} 
                                    onChange={event => handleSalaryInput(event, setRssDays)}
                                    />
                                }    

                                {(isNewEntrant && (absYear !== null) && (absYear.year() < earliestABSYear)) && <Typography sx={{ mt: 2, mb: 1 }}>The earliest ABS year we would expect would be {earliestABSYear} you have entered a year before this, please correct or leave this blank</Typography>}
                                {(!isNewEntrant && (absYear !== null) && (absYear.year() < earliestABSYear)) && <Typography sx={{ mt: 2, mb: 1 }}>The earliest ABS-RSS year we would expect would be {earliestABSYear} you have entered a year before this, please correct or leave this blank</Typography>}  
                                
                                {(isNewEntrant && (absYear === null) && 
                                    ((abs != null && abs.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") != "") || 
                                    (absLegacy != null && absLegacy.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") != "") || 
                                    ((rssYears != null || rssDays != null) && (rssYears.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") != "" || rssDays.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") != "")) || 
                                    ((rssLegacyYears != null || rssLegacyDays != null) && (rssLegacyYears.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") != "" || rssLegacyDays.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") != "")))) && 
                                    <Typography sx={{ mt: 2, mb: 1 }}>You have entered ABS values but not the ABS year, please add the ABS year or remove the ABS values</Typography>}

                                {(!isNewEntrant && (absYear === null) && 
                                    ((abs != null && abs.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") != "") || 
                                    (absLegacy != null && absLegacy.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") != "") || 
                                    ((rssYears != null || rssDays != null) && (rssYears.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") != "" || rssDays.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") != "")) || 
                                    ((rssLegacyYears != null || rssLegacyDays != null) && (rssLegacyYears.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") != "" || rssLegacyDays.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") != "")))) && 
                                    <Typography sx={{ mt: 2, mb: 1 }}>You have entered ABS-RSS values but not the ABS-RSS year, please add the ABS-RSS year or remove the ABS-RSS values</Typography>}

                                {(isNewEntrant && (absYear !== null) && 
                                    ((abs == null || abs.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") == "") || 
                                    (!isNewEntrant && (absLegacy == null || absLegacy.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") == "")) || 
                                    ((dateJoinedScheme < schemeDate2015) && (rssYears == null || rssYears.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") == "") && (rssDays == null || rssDays.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") == "")) || 
                                    (!isNewEntrant && (rssLegacyYears == null || rssLegacyYears.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") == "") && (rssLegacyDays == null || rssLegacyDays.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") == "")))) && 
                                    <Typography sx={{ mt: 2, mb: 1 }}>You have entered an ABS year but not a complete set of ABS values, please add the remaining ABS values or remove the ABS year</Typography>}

                                {(!isNewEntrant && (absYear !== null) && 
                                    ((abs == null || abs.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") == "") || 
                                    (!isNewEntrant && (absLegacy == null || absLegacy.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") == "")) || 
                                    ((dateJoinedScheme < schemeDate2015) && (rssYears == null || rssYears.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") == "") && (rssDays == null || rssDays.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") == "")) || 
                                    (!isNewEntrant && (rssLegacyYears == null || rssLegacyYears.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") == "") && (rssLegacyDays == null || rssLegacyDays.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") == "")))) && 
                                    <Typography sx={{ mt: 2, mb: 1 }}>You have entered an ABS-RSS year but not a complete set of ABS-RSS values, please add the remaining ABS-RSS values or remove the ABS-RSS year</Typography>}

                                <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                                    <Button variant="outlined"
                                    color="inherit"
                                    disabled={activeStep === 0}
                                    onClick={handleBack}
                                    sx={{ mr: 1 }}
                                    >
                                    Back
                                    </Button>
                                    <Box sx={{ flex: '1 1 auto' }} />
                                    {((currSalary !== "") || (prevSalary !=="")) && !((absYear !== null) && absYear.year() < earliestABSYear) && 
                                        !(((absYear === null) && 
                                        ((abs != null && abs.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") != "") || 
                                        (absLegacy != null && absLegacy.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") != "") || 
                                        ((rssYears != null || rssDays != null) && (rssYears.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") != "" || rssDays.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") != "")) || 
                                        ((rssLegacyYears != null || rssLegacyDays != null) && (rssLegacyYears.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") != "" || rssLegacyDays.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") != "")))) || 
                                        ((absYear !== null) && 
                                        ((abs == null || abs.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") == "") || 
                                        (!isNewEntrant && (absLegacy == null || absLegacy.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") == "")) || 
                                        ((dateJoinedScheme < schemeDate2015) && (rssYears == null || rssYears.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") == "") && (rssDays == null || rssDays.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") == "")) || 
                                        (!isNewEntrant && (rssLegacyYears == null || rssLegacyYears.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") == "") && (rssLegacyDays == null || rssLegacyDays.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") == ""))))) ? (
                                        <Button variant="outlined" style={{color:colorTheme,border:colorTheme,borderStyle:'solid',borderWidth:'1px'}}  onClick={handleNextSalary}>
                                        {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                                        </Button>
                                    ) : (
                                        <Button variant="outlined"
                                        style={{color:"rgb(198,198,198)"}}
                                        disabled
                                        onClick={handleNextSalary}>
                                        {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                                        </Button>
                                    )} 
                                </Box>
                                </React.Fragment>
                            </div>




                        ) : activeStep === 2 ? (

                            <div className="radio__container">
                                <React.Fragment>
                                <Typography sx={{ mt: 2, mb: 1 }}>Tell us about any past periods in which you worked part-time hours, and any planned part-time periods in the future.</Typography>
                                <Typography sx={{ mt: 2, mb: 1 }}>If you have never worked part-time hours, and do not intend to in the future, then leave this blank.</Typography>
                                <Typography sx={{ mt: 2, mb: 1 }}>You can also use this screen to input service breaks. You can do this by entering the period of the service break using the date inputs, then setting the percentage to 0%.</Typography>
                                {isNewEntrant && (absYear !== null) &&
                                    <Typography sx={{ mt: 2, mb: 1 }}>As you have provided ABS values, only part-time hours for the period after the ABS statement need to be entered.</Typography>
                                }
                                {!isNewEntrant && (absYear !== null) &&
                                    <Typography sx={{ mt: 2, mb: 1 }}>As you have provided ABS-RSS values, only part-time hours for the period after the ABS-RSS statement need to be entered.</Typography>
                                }
                                {partTime.map((period, index) => (
                                    <PartTimePeriod index={index} 
                                                    partTime={partTime} 
                                                    setPartTime={setPartTime} 
                                                    periodFrom={period.from}
                                                    periodTo={period.to} 
                                                    periodProportion={period.proportion} 
                                                    dateJoinedScheme={dateJoinedScheme} 
                                                    dateLeftScheme={dateLeftScheme}
                                                    validPartTimeFlag={validPartTimeFlag}
                                                    setValidPartTimeFlag={setValidPartTimeFlag}
                                                    fillPartTimeFlag={fillPartTimeFlag}
                                                    setFillPartTimeFlag={setFillPartTimeFlag}/>
                                    ))}

                                {partTimeOverlapWarning === true ? (
                                    <p>You can not have overlapping periods of part-time service</p>
                                ) : (
                                    null
                                )}
                                
                                <div className="addcircle__container" onClick={() => handleAddPartTimeField(partTime.length -1)}>
                                    <AddCircleIcon style={{fontSize:"30px"}}/>
                                    <p>Add row</p>  
                                </div>

                                {/* {fillPartTimeFlag === false ? (
                                    null
                                ) : (
                                    <p>Please fill in any empty boxes or correct any errors before adding another period of part-time service.</p>
                                )} */}

                                {fillPartTimeFlag === false && validPartTimeFlag === true ? (
                                    null
                                ) : (
                                    <div>
                                        <Typography sx={{ mt: 2, mb: 1 }}>Please fill in any empty boxes or correct any errors before adding another period of part-time service or before clicking 'NEXT'</Typography>
                                        <Typography sx={{ mt: 2, mb: 1 }}>For a given period of part time service, all three fields must be filled in ('From', 'To' and 'Percentage'). Any blanks will be treated as an error. Other errors in the inputs will be highlighted in red and an error message will appear with more information.</Typography>
                                        <Typography sx={{ mt: 2, mb: 1 }}>Note that any periods of part time service which are left blank or contain errors will be ignored.</Typography>
                                    </div>
                                    

                                )}
                             
                                <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                                    <Button variant="outlined"
                                    color="inherit"
                                    disabled={activeStep === 0}
                                    onClick={handleBack}
                                    sx={{ mr: 1 }}
                                    >
                                    Back
                                    </Button>
                                    <Box sx={{ flex: '1 1 auto' }} />
                                    <Button variant="outlined" style={{color:colorTheme,border:colorTheme,borderStyle:'solid',borderWidth:'1px'}}  onClick={handleNext}>
                                    {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                                    </Button>
                                </Box>
                                </React.Fragment>
                            </div>
                        ) : (
                            <div className="radio__container">
                                <React.Fragment>
                                    <Typography sx={{ mt: 2, mb: 1 }}>What you told us</Typography>
                                    <TableContainer component={Paper} style={{marginTop:"20px"}}>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Your Details</TableCell>
                                                    <TableCell></TableCell>
                                                </TableRow>                                               
                                            </TableHead>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell>Scheme</TableCell>
                                                    <TableCell>{scheme}</TableCell>
                                                </TableRow>
                                                {scheme === '1995' && statusName.includes('Special') && (
                                                <TableRow>
                                                    <TableCell>Special Status</TableCell>
                                                    <TableCell>Yes</TableCell>
                                                </TableRow>)}
                                                {scheme === '1995' && statusName.includes('MHO') && (
                                                <TableRow>
                                                    <TableCell>MHO Status</TableCell>
                                                    <TableCell>Yes</TableCell>
                                                </TableRow>)}
                                                <TableRow>
                                                    <TableCell>Date Of Birth</TableCell>
                                                    <TableCell>{moment(dateOfBirth).format("DD/MM/YYYY")}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>Date Joined Scheme</TableCell>
                                                    <TableCell>{moment(dateJoinedScheme).format("DD/MM/YYYY")}</TableCell>
                                                </TableRow>
                                                {dateLeftScheme === null ? (
                                                <TableRow>
                                                    <TableCell>Date Left Scheme</TableCell>
                                                    <TableCell>N/A</TableCell>
                                                </TableRow>
                                                ) : (
                                                <TableRow>
                                                    <TableCell>Date Left Scheme</TableCell>
                                                    <TableCell>{moment(dateLeftScheme).format("DD/MM/YYYY")}</TableCell>
                                                </TableRow>
                                                )}
                                                {hasLeftScheme === false && 
                                                (<TableRow>
                                                    <TableCell>Date of Chosen Retirement</TableCell>
                                                    <TableCell>{moment(dateOfChosenRetirement).format("DD/MM/YYYY")}</TableCell>
                                                </TableRow>)}
                                                <TableRow>
                                                    <TableCell>Current Salary</TableCell>
                                                    <TableCell>£ {currSalary.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</TableCell>
                                                </TableRow>
                                                {prevSalary === null || prevSalary === '' ? (
                                                <TableRow>
                                                    <TableCell>Previous Salary</TableCell>
                                                    <TableCell>N/A</TableCell>
                                                </TableRow>
                                                ) : (
                                                <TableRow>
                                                    <TableCell>Previous Salary</TableCell>
                                                    <TableCell>£ {prevSalary.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</TableCell>
                                                </TableRow>
                                                )}
                                                {/* {region === 'England & Wales' && 
                                                <TableRow>
                                                    <TableCell>Metropolitan Police</TableCell>
                                                    <TableCell>{isMemberOfMet !== true ? ("No") : ("Yes")}</TableCell>

                                                </TableRow>} */}

                                                {/* <TableRow>
                                                    <TableCell>Rank</TableCell>
                                                    <TableCell>{rankAtRetirement}</TableCell>
                                                </TableRow> */}
                                                {isNewEntrant && (absYear != null) && (
                                                    <TableRow>
                                                    <TableCell>Annual Benefit Statement Year</TableCell>
                                                    <TableCell>{absYear.year()}</TableCell>
                                                </TableRow>
                                                )}
                                                {!isNewEntrant && (absYear != null) && (
                                                    <TableRow>
                                                    <TableCell>Annual Benefit and Remedial Service Statement Year</TableCell>
                                                    <TableCell>{absYear.year()}</TableCell>
                                                </TableRow>
                                                )}
                                                {(absLegacy != null && absLegacy.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") != "") && (
                                                    <TableRow>
                                                    <TableCell>2015 CARE Scheme Pension following transition in 2022</TableCell>
                                                    <TableCell>£ {absLegacy.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</TableCell>
                                                </TableRow>
                                                )}
                                                {((rssLegacyYears != null || rssLegacyDays != null) && (rssLegacyYears.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") != "" || rssLegacyDays.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") != "")) && (
                                                    <TableRow>
                                                    <TableCell>Years of legacy service to 2022</TableCell>
                                                    <TableCell>{rssLegacyYears.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</TableCell>
                                                </TableRow>
                                                )}
                                                {((rssLegacyYears != null || rssLegacyDays != null) && (rssLegacyYears.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") != "" || rssLegacyDays.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") != "")) && (
                                                    <TableRow>
                                                    <TableCell>Days of legacy service to 2022</TableCell>
                                                    <TableCell>{rssLegacyDays.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</TableCell>
                                                </TableRow>
                                                )}
                                                {(abs != null && abs.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") != "") && (
                                                    <TableRow>
                                                    <TableCell>2015 CARE Scheme Pension following transition in 2015</TableCell>
                                                    <TableCell>£ {abs.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</TableCell>
                                                </TableRow>
                                                )}
                                                {((rssYears != null || rssDays != null) && (rssYears.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") != "" || rssDays.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") != "")) && (
                                                    <TableRow>
                                                    <TableCell>Years of legacy service to 2015</TableCell>
                                                    <TableCell>{rssYears.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</TableCell>
                                                </TableRow>
                                                )}
                                                {((rssYears != null || rssDays != null) && (rssYears.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") != "" || rssDays.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") != "")) && (
                                                    <TableRow>
                                                    <TableCell>Days of legacy service to 2015</TableCell>
                                                    <TableCell>{rssDays.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</TableCell>
                                                </TableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                    <TableContainer component={Paper} style={{marginTop:"15px"}}>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Part-time Service</TableCell>
                                                    <TableCell></TableCell>
                                                    <TableCell></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell>Start Date</TableCell>
                                                    <TableCell>End Date</TableCell>
                                                    <TableCell>Percentage (%)</TableCell>
                                                </TableRow>
                                                {partTime.map((period, i) => (
                                                <TableRow key={i}>
                                                    <TableCell>{moment(period['from']).format("DD/MM/YYYY")}</TableCell>
                                                    <TableCell>{moment(period['to']).format("DD/MM/YYYY")}</TableCell>
                                                    <TableCell>{period['proportion']}</TableCell>                                                   
                                                </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                    <Typography sx={{ mt: 2, mb: 1 }}>
                                        Go back to make any changes or continue to Your Summary
                                    </Typography>
                                    <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                                        <Button variant="outlined"
                                            color="inherit"
                                            disabled={activeStep === 0}
                                            onClick={handleBack}
                                            sx={{ mr: 1 }}
                                            >
                                            Back
                                        </Button>
                                        <Box sx={{ flex: '1 1 auto' }} />
                                        <Button variant="outlined" style={{color:colorTheme,border:colorTheme,borderStyle:'solid',borderWidth:'1px'}}  onClick={handleSubmit}>Continue</Button>
                                    </Box>
                                </React.Fragment>
                            </div>  
                        )}
                    </Box>
                </div>
            </div>
    )
}

export default AboutYou
